import { ReactRenderer } from '@tiptap/react';
import type {
    SuggestionKeyDownProps,
    SuggestionOptions,
    SuggestionProps,
} from '@tiptap/suggestion';
import type { UserInfoWithIdT } from 'business/definitions';
import Loading from 'components/Loading';
import Fuse from 'fuse.js';

import MentionList from './MentionList';

// that filtering is not good
const filterUsers = (
    users: UserInfoWithIdT[],
    query: string,
): UserInfoWithIdT[] => {
    if (query === '') {
        return users.sort((userA, userB) => {
            const userAStr =
                (userA.firstname ?? '') +
                (userA.lastname ?? '') +
                (userA.email ?? '');
            const userBStr =
                (userB.firstname ?? '') +
                (userB.lastname ?? '') +
                (userB.email ?? '');
            return userAStr.localeCompare(userBStr);
        });
    }
    const fuse = new Fuse(users, {
        keys: ['firstname', 'lastname', 'email'],
        threshold: 0.4,
    });
    return fuse.search(query).map((o) => o.item);
};

export const Suggestion = (
    users: UserInfoWithIdT[] | undefined,
    trackMentionCreation?: () => void,
): {
    char: string;
    items: ({ query }: { query: string }) => UserInfoWithIdT[];
    render: () => ReturnType<NonNullable<SuggestionOptions['render']>>;
} => ({
    char: '@',
    items: ({ query }) => filterUsers(users === undefined ? [] : users, query),
    render: () => {
        let component: ReactRenderer;

        return {
            onStart: (props: SuggestionProps) => {
                component =
                    users === undefined
                        ? new ReactRenderer(Loading, {
                              props,
                              editor: props.editor,
                          })
                        : new ReactRenderer(MentionList, {
                              props: { ...props, trackMentionCreation },
                              editor: props.editor,
                          });
            },

            onUpdate(props: SuggestionProps) {
                component.updateProps(props);
            },

            onKeyDown(props: SuggestionKeyDownProps) {
                if (props.event.key === 'Escape') {
                    component.destroy();
                    return true;
                }

                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return (component.ref as any)?.onKeyDown(props);
            },

            onExit() {
                component.destroy();
            },
        };
    },
});
